import { render, staticRenderFns } from "./CourseActions.vue?vue&type=template&id=5007ceb4&scoped=true"
import script from "./CourseActions.vue?vue&type=script&lang=js"
export * from "./CourseActions.vue?vue&type=script&lang=js"
import style0 from "./CourseActions.vue?vue&type=style&index=0&id=5007ceb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007ceb4",
  null
  
)

export default component.exports